import React from 'react';
import { Paper } from '@mui/material';
import Grid from '@mui/material/Grid';
import FormField from '../Common/FormField';
import SkillsSection from '../Common/SkillsSection';
import StateDropdown from '../Common/StateDropdown';
import CityDropdown from '../Common/CityDropdown';
import { PersonalInfoFieldsProps, SkillEntry } from '../../types/profileForm.types';
import { UserInitialStateType } from 'DataTypes/Redux';
import { useSelector } from 'react-redux';

const PersonalInfoFields: React.FC<PersonalInfoFieldsProps> = ({
  formData,
  errors,
  onChange,
  onBlur,
}) => {
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  // console.log("Rendering PersonalInfoFields with formData:", formData, );

  // Handle state change to clear city when state changes
  const handleStateChange = (name: string, value: string) => {
    // Clear city if state changes
    if (name === 'state' && value !== formData.state && formData.city) {
      onChange('city', '');
    }
    console.log(`State changed: ${name} = ${value}`);
    onChange(name, value);
  };

  // Handle skills section changes
  const handleSkillsChange = (skillEntries: SkillEntry[]) => {
    console.log("Skills changed:", skillEntries);
    onChange('skillEntries', skillEntries);
  };
  return (
    <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 }, borderRadius: '12px', mb: 2 }}>
      <Grid container columnSpacing={12} rowSpacing={2}>
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <FormField
            label="Name"
            name="name"
            type="text"
            value={formData.name}
            error={errors.name}
            placeholder="Enter your full name"
            required
            onChange={onChange}
            onBlur={onBlur}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <FormField
            label="Email Address"
            name="email"
            type="email"

            value={formData.email}
            error={errors.email}
            placeholder="Enter your email address"
            required
            onChange={onChange}
            onBlur={onBlur}
            disabled
          // Email is not editable
          />
        </Grid>
{/* if user is NRI, and there defult number is 0000000000 then enable the phone number field */}
        {/* <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <FormField
            label="Phone Number"
            name="phone"
            type="tel"
            value={formData.phone}
            error={errors.phone}
            placeholder="Enter your phone number"
            required
            onChange={onChange}
            onBlur={onBlur}
            disabled
          />
        </Grid> */}

          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <FormField
              label="Phone Number"
              name="phone"
              type="tel"
              value={formData.phone}
              error={errors.phone}
              placeholder="Enter your phone number"
              required
              inputProps={{ maxLength: 10 }}
              onChange={onChange}
            onBlur={onBlur}
            disabled={String(myInfo?.phone) !== '0000000000'}
            />
          </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <FormField
            label="Date of Birth"
            name="dateOfBirth"
            type="date"
            value={formData.dateOfBirth}
            error={errors.dateOfBirth}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <FormField
            label="Address"
            name="address"
            type="text"
            value={formData.address}
            error={errors.address}
            placeholder="Enter your address"
            onChange={onChange}
            onBlur={onBlur}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <StateDropdown
            label="State"
            value={formData.state || ''}
            error={errors.state}
            onChange={handleStateChange}
            onBlur={onBlur}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <CityDropdown
            label="City"
            value={formData.city || ''}
            selectedState={formData.state || ''}
            error={errors.city}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <FormField
            label="Postal Code"
            name="postalCode"
            type="text"
            value={formData.postalCode}
            error={errors.postalCode}
            placeholder="Enter your postal code"
            onChange={onChange}
            onBlur={onBlur}
          />
        </Grid>

        {/* <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <FormField
            label="Highest Qualification"
            name="highestQualification"
            type="text"
            value={formData.highestQualification || ''}
            error={errors.highestQualification}
            placeholder="Enter your highest qualification"
            onChange={onChange}
            onBlur={onBlur}
          />
        </Grid> */}

        {myInfo.userType === "CORPORATEUSER" && (
           <Grid size={{ xs: 12, sm: 6, md: 6 }}>
              <FormField
                label="Organisation Name"
                name="organisationName"
                type="text"
                value={formData.organisationName || ''}
                error={errors.organisationName}
                placeholder="Enter your organisation name"
                onChange={onChange}
                onBlur={onBlur}
                disabled
              />
            </Grid>
        )}

        {myInfo?.userType === 'PROFESSIONAL' && (
          <>
            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
              <FormField
                label="Highest Qualification"
                name="highestQualification"
                type="text"
                value={formData.highestQualification || ''}
                error={errors.highestQualification}
                placeholder="Enter your highest qualification"
                onChange={onChange}
                onBlur={onBlur}
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <SkillsSection
                skillEntries={formData.skillEntries || []}
                errors={errors.skillEntries}
                onChange={handleSkillsChange}
                onBlur={onBlur}
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <FormField
                label="Description"
                name="description"
                type="textarea"
                value={formData.description}
                error={errors.description}
                placeholder="Write a short professional bio..."
                onChange={onChange}
                onBlur={onBlur}
              />
            </Grid>

          </>
        )}



        {/* <Grid size={{ xs: 12 }}>
          <SkillsSection
            skillEntries={formData.skillEntries || []}
            errors={errors.skillEntries}
            onChange={handleSkillsChange}
            onBlur={onBlur}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <FormField
            label="Description"
            name="description"
            type="textarea"
            value={formData.description}
            error={errors.description}
            placeholder="Write a short professional bio..."
            onChange={onChange}
            onBlur={onBlur}
          />
        </Grid> */}
      </Grid>
    </Paper>
  );
};

export default PersonalInfoFields;